import { z } from 'zod';

import { FeatureFlagDefault, FlagDefinition, FlagVerdict, TenantFlagOverride } from './flag';

/**
 * One flag as it applies to a single museum — `GET /api/tenants/:id/flags`.
 *
 * The four parts are kept apart because each answers a different question, and
 * the API keeps them apart for the same reason (see `TenantFlagView` in the
 * API's `get-tenant-flags.use-case.ts`):
 *
 * - `definition` is the editorial row. Nothing resolves from it.
 * - `default` is what every museum without an override gets.
 * - `override` is this museum's own row, or `null` when it inherits.
 * - `verdict` is what this museum *actually* gets, computed server-side.
 *
 * The UI renders the verdict rather than any stored `enabled`: an override of
 * `true` on an archived flag still resolves `false`, and showing the stored
 * toggle there would tell an operator the opposite of the truth.
 */
export const TenantFlagView = z.object({
    definition: FlagDefinition,
    default: FeatureFlagDefault,
    override: TenantFlagOverride.nullable(),
    verdict: FlagVerdict,
});
export type TenantFlagView = z.infer<typeof TenantFlagView>;

export const TenantFlagsResponse = z.object({ flags: z.array(TenantFlagView) });
